import React from "react";

import PNG_One from "../../../assets/images/raster/components/ProValue/ProValue_1.png";
import PNG_One_1200 from "../../../assets/images/raster/components/ProValue/ProValue_1@1200.png";
import PNG_One_992 from "../../../assets/images/raster/components/ProValue/ProValue_1@992.png";
import PNG_One_768 from "../../../assets/images/raster/components/ProValue/ProValue_1@768.png";
import PNG_One_mob from "../../../assets/images/raster/components/ProValue/ProValue_1@mob.png";

import WEBP_One from "../../../assets/images/raster/components/ProValue/ProValue_1.webp";
import WEBP_One_1200 from "../../../assets/images/raster/components/ProValue/ProValue_1@1200.webp";
import WEBP_One_992 from "../../../assets/images/raster/components/ProValue/ProValue_1@992.webp";
import WEBP_One_768 from "../../../assets/images/raster/components/ProValue/ProValue_1@768.webp";
import WEBP_One_mob from "../../../assets/images/raster/components/ProValue/ProValue_1@mob.webp";

import PNG_Two from "../../../assets/images/raster/components/ProValue/ProValue_2.png";
import PNG_Two_1200 from "../../../assets/images/raster/components/ProValue/ProValue_2@1200.png";
import PNG_Two_992 from "../../../assets/images/raster/components/ProValue/ProValue_2@992.png";
import PNG_Two_768 from "../../../assets/images/raster/components/ProValue/ProValue_2@768.png";
import PNG_Two_mob from "../../../assets/images/raster/components/ProValue/ProValue_2@mob.png";

import WEBP_Two from "../../../assets/images/raster/components/ProValue/ProValue_2.webp";
import WEBP_Two_1200 from "../../../assets/images/raster/components/ProValue/ProValue_2@1200.webp";
import WEBP_Two_992 from "../../../assets/images/raster/components/ProValue/ProValue_2@992.webp";
import WEBP_Two_768 from "../../../assets/images/raster/components/ProValue/ProValue_2@768.webp";
import WEBP_Two_mob from "../../../assets/images/raster/components/ProValue/ProValue_2@mob.webp";

import PNG_Three from "../../../assets/images/raster/components/ProValue/ProValue_3.png";
import PNG_Three_1200 from "../../../assets/images/raster/components/ProValue/ProValue_3@1200.png";
import PNG_Three_992 from "../../../assets/images/raster/components/ProValue/ProValue_3@992.png";
import PNG_Three_768 from "../../../assets/images/raster/components/ProValue/ProValue_3@768.png";
import PNG_Three_mob from "../../../assets/images/raster/components/ProValue/ProValue_3@mob.png";

import WEBP_Three from "../../../assets/images/raster/components/ProValue/ProValue_3.webp";
import WEBP_Three_1200 from "../../../assets/images/raster/components/ProValue/ProValue_3@1200.webp";
import WEBP_Three_992 from "../../../assets/images/raster/components/ProValue/ProValue_3@992.webp";
import WEBP_Three_768 from "../../../assets/images/raster/components/ProValue/ProValue_3@768.webp";
import WEBP_Three_mob from "../../../assets/images/raster/components/ProValue/ProValue_3@mob.webp";

import PNG_Four from "../../../assets/images/raster/components/ProValue/ProValue_4.png";
import PNG_Four_1200 from "../../../assets/images/raster/components/ProValue/ProValue_4@1200.png";
import PNG_Four_992 from "../../../assets/images/raster/components/ProValue/ProValue_4@992.png";
import PNG_Four_768 from "../../../assets/images/raster/components/ProValue/ProValue_4@768.png";
import PNG_Four_mob from "../../../assets/images/raster/components/ProValue/ProValue_4@mob.png";

import WEBP_Four from "../../../assets/images/raster/components/ProValue/ProValue_4.webp";
import WEBP_Four_1200 from "../../../assets/images/raster/components/ProValue/ProValue_4@1200.webp";
import WEBP_Four_992 from "../../../assets/images/raster/components/ProValue/ProValue_4@992.webp";
import WEBP_Four_768 from "../../../assets/images/raster/components/ProValue/ProValue_4@768.webp";
import WEBP_Four_mob from "../../../assets/images/raster/components/ProValue/ProValue_4@mob.webp";

import PNG_Five from "../../../assets/images/raster/components/ProValue/ProValue_5.png";
import PNG_Five_1200 from "../../../assets/images/raster/components/ProValue/ProValue_5@1200.png";
import PNG_Five_992 from "../../../assets/images/raster/components/ProValue/ProValue_5@992.png";
import PNG_Five_768 from "../../../assets/images/raster/components/ProValue/ProValue_5@768.png";
import PNG_Five_mob from "../../../assets/images/raster/components/ProValue/ProValue_5@mob.png";

import WEBP_Five from "../../../assets/images/raster/components/ProValue/ProValue_5.webp";
import WEBP_Five_1200 from "../../../assets/images/raster/components/ProValue/ProValue_5@1200.webp";
import WEBP_Five_992 from "../../../assets/images/raster/components/ProValue/ProValue_5@992.webp";
import WEBP_Five_768 from "../../../assets/images/raster/components/ProValue/ProValue_5@768.webp";
import WEBP_Five_mob from "../../../assets/images/raster/components/ProValue/ProValue_5@mob.webp";

import PNG_Six from "../../../assets/images/raster/components/ProValue/ProValue_6.png";
import PNG_Six_1200 from "../../../assets/images/raster/components/ProValue/ProValue_6@1200.png";
import PNG_Six_992 from "../../../assets/images/raster/components/ProValue/ProValue_6@992.png";
import PNG_Six_768 from "../../../assets/images/raster/components/ProValue/ProValue_6@768.png";
import PNG_Six_mob from "../../../assets/images/raster/components/ProValue/ProValue_6@mob.png";

import WEBP_Six from "../../../assets/images/raster/components/ProValue/ProValue_6.webp";
import WEBP_Six_1200 from "../../../assets/images/raster/components/ProValue/ProValue_6@1200.webp";
import WEBP_Six_992 from "../../../assets/images/raster/components/ProValue/ProValue_6@992.webp";
import WEBP_Six_768 from "../../../assets/images/raster/components/ProValue/ProValue_6@768.webp";
import WEBP_Six_mob from "../../../assets/images/raster/components/ProValue/ProValue_6@mob.webp";

import JPG_US from "../../../assets/images/raster/components/ProValue/flags/us.jpg";
import JPG_US_mob from "../../../assets/images/raster/components/ProValue/flags/us@mob.jpg";

import JPG_JP from "../../../assets/images/raster/components/ProValue/flags/jp.jpg";
import JPG_JP_mob from "../../../assets/images/raster/components/ProValue/flags/jp@mob.jpg";

import JPG_AE from "../../../assets/images/raster/components/ProValue/flags/ae.jpg";
import JPG_AE_mob from "../../../assets/images/raster/components/ProValue/flags/ae@mob.jpg";

import JPG_CA from "../../../assets/images/raster/components/ProValue/flags/ca.jpg";
import JPG_CA_mob from "../../../assets/images/raster/components/ProValue/flags/ca@mob.jpg";

import JPG_DE from "../../../assets/images/raster/components/ProValue/flags/de.jpg";
import JPG_DE_mob from "../../../assets/images/raster/components/ProValue/flags/de@mob.jpg";

import JPG_FR from "../../../assets/images/raster/components/ProValue/flags/fr.jpg";
import JPG_FR_mob from "../../../assets/images/raster/components/ProValue/flags/fr@mob.jpg";

import JPG_UK from "../../../assets/images/raster/components/ProValue/flags/uk.jpg";
import JPG_UK_mob from "../../../assets/images/raster/components/ProValue/flags/uk@mob.jpg";

import JPG_MX from "../../../assets/images/raster/components/ProValue/flags/mx.jpg";
import JPG_MX_mob from "../../../assets/images/raster/components/ProValue/flags/mx@mob.jpg";

import JPG_IT from "../../../assets/images/raster/components/ProValue/flags/it.jpg";
import JPG_IT_mob from "../../../assets/images/raster/components/ProValue/flags/it@mob.jpg";

import JPG_ES from "../../../assets/images/raster/components/ProValue/flags/es.jpg";
import JPG_ES_mob from "../../../assets/images/raster/components/ProValue/flags/es@mob.jpg";

import JPG_SA from "../../../assets/images/raster/components/ProValue/flags/sa.jpg";
import JPG_SA_mob from "../../../assets/images/raster/components/ProValue/flags/sa@mob.jpg";

import JPG_IN from "../../../assets/images/raster/components/ProValue/flags/in.jpg";
import JPG_IN_mob from "../../../assets/images/raster/components/ProValue/flags/in@mob.jpg";

import JPG_AU from "../../../assets/images/raster/components/ProValue/flags/au.jpg";
import JPG_AU_mob from "../../../assets/images/raster/components/ProValue/flags/au@mob.jpg";

import JPG_BR from "../../../assets/images/raster/components/ProValue/flags/br.jpg";
import JPG_BR_mob from "../../../assets/images/raster/components/ProValue/flags/br@mob.jpg";
import TrackedLink from "../../Analytics/TrackedLink";
import { ANALYTICS_CATEGORY } from "../../../helpers/constants";
import { URL_LABEL } from "../index.content";

const Link = ({ text, path, showMobileProPopup }) => (
  <TrackedLink
    classes="PgESM-PV-D__link"
    category={ANALYTICS_CATEGORY.ES}
    action={text}
    path={path}
    showMobileProPopup={showMobileProPopup}
  >
    {text}
  </TrackedLink>
);
const LINK_PROPS = {
  PRODUCT_DATABASE: {
    text: "Base de datos de productos",
    path: `/product-database/?${URL_LABEL}_t`,
  },
  PRO_EXTENSION: {
    text: "Extensión PRO",
    path: `/pro/?${URL_LABEL}_t`,
  },
  PRO_AI_EXTENSION: {
    text: "Extensión PRO AI",
    path: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=es_t`,
    showMobileProPopup: true,
  },
  PROFITABLE_PRODUCTS: {
    text: "productos rentables",
    path: `/app/#/reports/insights?${URL_LABEL}_t`,
  },
  STEP_BY_STEP_VIDEO_COURSES: {
    text: "cursos paso a paso",
    path: `/amazon-private-label-course?${URL_LABEL}_t`,
  },
  MASTERCLASSES: {
    text: "clases magistrales",
    path: `/free-amazon-fba-masterclasses?${URL_LABEL}_t`,
  },
  LIVE_WORKSHOPS: {
    text: "talleres EN VIVO",
    path: `https://learn.amzscout.net/free-masterclass?${URL_LABEL}_t`,
  },
  SPOT_PRODUCTS_EASILY: {
    text: "Encuentra productos fácilmente",
    path: `/amazon-toolkit/?${URL_LABEL}_t`,
  },
  PRODUCTS_NEED_ADDITIONAL_INVESTMENT: {
    text: "productos necesitan una inversión adicional",
    path: `/online-arbitrage/?${URL_LABEL}_t`,
  },
  AFFORDABLE_AND_TRUSTWORTHY_SUPPLIERS: {
    text: "proveedores asequibles y confiables",
    path: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=es_t`,
    showMobileProPopup: true,
  },
  AMZSCOUT_KEYWORD_TOOLS: {
    text: "herramientas de palabras clave de AMZScout",
    path: `/amazon-keyword-tools/?${URL_LABEL}_t`,
  },
};

const BUTTONS = {
  PRODUCT_DATABASE: {
    text: "Base de datos de productos",
    path: `/app/#/database?${URL_LABEL}_p`,
  },
  WEEKLY_HOT_PRODUCTS: {
    text: "Productos populares semanales",
    path: `/app/#/reports/insights?${URL_LABEL}_p`,
  },
  COURSES: {
    text: "Cursos",
    path: `/amazon-private-label-course?${URL_LABEL}_p`,
  },
  MASTERCLASSES: {
    text: "Clases magistrales",
    path: `/free-amazon-fba-masterclasses?${URL_LABEL}_p`,
  },
  LIVE_WORKSHOPS: {
    text: "Talleres EN VIVO",
    path: `https://learn.amzscout.net/free-masterclass?${URL_LABEL}_p`,
  },
  INSTALL_DROPSHIPPING_ARBITRAGE_AND_WHOLESALE_EXTENSION: {
    text: "Instalar la extensión de Dropshipping, Arbitrage y Wholesale",
    path: "https://chromewebstore.google.com/detail/amazon-dropshipping-arbit/edkgpjhfpfpgkohafpaliolcfnijnibh?utm_source=site&utm_medium=amzscout&utm_campaign=es_p",
    target: true,
  },
  INSTALL_PRO_EXTENSION_FOR_CHROME_AND_EDGE: {
    text: "Instalar la extensión PRO para Chrome y Edge",
    path: `${process.env.SCOUT_EXT_PRO}?utm_source=site&utm_medium=amzscout&utm_campaign=es_p`,
    target: true,
    showMobileProPopup: true,
  },
  INSTALL_PRO_AI_EXTENSION_FOR_CHROME_AND_EDGE: {
    text: "Instalar la Extensión PRO AI para Chrome y Edge",
    path: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=es_p`,
    target: true,
    showMobileProPopup: true,
  },
  AMAZON_KEYWORD_SEARCH: {
    text: "Búsqueda de palabras clave de Amazon",
    path: `/app/#/keywords?${URL_LABEL}_p`,
  },
  PRODUCT_KEYWORDS_2_0: {
    text: "Palabras clave de producto 2.0",
    path: `/app/#/product-keywords?${URL_LABEL}_p`,
  },
};

export const LIST_OF_ITEMS = [
  {
    screen: {
      PNG: PNG_One,
      PNG_1200: PNG_One_1200,
      PNG_992: PNG_One_992,
      PNG_768: PNG_One_768,
      PNG_mob: PNG_One_mob,
      WEBP: WEBP_One,
      WEBP_1200: WEBP_One_1200,
      WEBP_992: WEBP_One_992,
      WEBP_768: WEBP_One_768,
      WEBP_mob: WEBP_One_mob,
    },
    buttons: [BUTTONS.PRODUCT_DATABASE, BUTTONS.WEEKLY_HOT_PRODUCTS],
    title: "Encontrar productos rentables para vender en Amazon",
    isNumberedList: true,
    text: [
      <>Genera nuevas ideas de productos populares utilizando la <Link {...LINK_PROPS.PRODUCT_DATABASE} /> que incluye 550 millones de artículos</>,
      <>Identifica y compara productos con el mayor potencial de beneficio y evalúa la competencia utilizando la legendaria <Link {...LINK_PROPS.PRO_AI_EXTENSION} /></>,
      <>Obtén <Link {...LINK_PROPS.PROFITABLE_PRODUCTS} /> que están en el 1% superior, entregados directamente a tu correo electrónico</>,
      "Accede a la solución de análisis más precisa de la industria",
    ],
  },
  {
    screen: {
      PNG: PNG_Two,
      PNG_1200: PNG_Two_1200,
      PNG_992: PNG_Two_992,
      PNG_768: PNG_Two_768,
      PNG_mob: PNG_Two_mob,
      WEBP: WEBP_Two,
      WEBP_1200: WEBP_Two_1200,
      WEBP_992: WEBP_Two_992,
      WEBP_768: WEBP_Two_768,
      WEBP_mob: WEBP_Two_mob,
    },
    buttons: [BUTTONS.COURSES, BUTTONS.MASTERCLASSES, BUTTONS.LIVE_WORKSHOPS],
    title: "Aprende cómo vender en el mercado de Amazon",
    text: [
      <>Ve exactamente cómo elegir productos rentables, obtener artículos de proveedores y comercializar tu negocio con <Link {...LINK_PROPS.STEP_BY_STEP_VIDEO_COURSES} /> y <Link {...LINK_PROPS.MASTERCLASSES} /> creados por vendedores de Amazon con ingresos de siete cifras.</>,
      <>Regístrate y asiste a nuestros <Link {...LINK_PROPS.LIVE_WORKSHOPS} /> con vendedores exitosos de Amazon y entrenadores para aprender consejos y trucos, desde abrir una cuenta en Amazon hasta implementar nuevas estrategias de venta para administrar tu negocio actual.</>,
    ],
  },
  {
    screen: {
      PNG: PNG_Three,
      PNG_1200: PNG_Three_1200,
      PNG_992: PNG_Three_992,
      PNG_768: PNG_Three_768,
      PNG_mob: PNG_Three_mob,
      WEBP: WEBP_Three,
      WEBP_1200: WEBP_Three_1200,
      WEBP_992: WEBP_Three_992,
      WEBP_768: WEBP_Three_768,
      WEBP_mob: WEBP_Three_mob,
    },
    buttons: [BUTTONS.INSTALL_DROPSHIPPING_ARBITRAGE_AND_WHOLESALE_EXTENSION],
    title: "Genera grandes ganancias vendiendo productos probados y rentables",
    isNumberedList: true,
    text: [
      <><Link {...LINK_PROPS.SPOT_PRODUCTS_EASILY} /> que sean adecuados para dropshipping, arbitraje y mayoristas</>,
      "Calcula el precio necesario para obtener la Buy Box, y cuántas ventas puedes hacer",
      <>Descubre qué <Link {...LINK_PROPS.PRODUCTS_NEED_ADDITIONAL_INVESTMENT} /> y permisos especiales para vender sin problemas</>,
    ],
  },
  {
    screen: {
      PNG: PNG_Four,
      PNG_1200: PNG_Four_1200,
      PNG_992: PNG_Four_992,
      PNG_768: PNG_Four_768,
      PNG_mob: PNG_Four_mob,
      WEBP: WEBP_Four,
      WEBP_1200: WEBP_Four_1200,
      WEBP_992: WEBP_Four_992,
      WEBP_768: WEBP_Four_768,
      WEBP_mob: WEBP_Four_mob,
    },
    buttons: [BUTTONS.INSTALL_PRO_AI_EXTENSION_FOR_CHROME_AND_EDGE],
    title: "Buscar proveedores locales e internacionales en Alibaba",
    isNumberedList: true,
    text: [
      <>Descubre <Link {...LINK_PROPS.AFFORDABLE_AND_TRUSTWORTHY_SUPPLIERS} /> de cualquier país, incluidos EE. UU. y China, con solo un clic</>,
      "Accede a millones de fabricantes que están listos para crear productos de marca privada",
      "Encuentra los productos de tus competidores en Alibaba.com y agréguelos a tu inventario para escalar tu negocio",
      "Compara proveedores por calificación y actividad comercial para elegir los socios más confiables para tu negocio",
    ],
  },
  {
    screen: {
      PNG: PNG_Five,
      PNG_1200: PNG_Five_1200,
      PNG_992: PNG_Five_992,
      PNG_768: PNG_Five_768,
      PNG_mob: PNG_Five_mob,
      WEBP: WEBP_Five,
      WEBP_1200: WEBP_Five_1200,
      WEBP_992: WEBP_Five_992,
      WEBP_768: WEBP_Five_768,
      WEBP_mob: WEBP_Five_mob,
    },
    buttons: [BUTTONS.AMAZON_KEYWORD_SEARCH, BUTTONS.PRODUCT_KEYWORDS_2_0],
    title: "Lanza un producto exitoso rápidamente",
    isNumberedList: true,
    text: [
      <>Obtén todas las palabras clave que necesitas para crear listados efectivos de productos y campañas de PPC con las <Link {...LINK_PROPS.AMZSCOUT_KEYWORD_TOOLS} /></>,
      "Recibe informes que te ayudarán a afinar tus listados y superar a tus competidores",
      "Crea los listados y campañas de PPC perfectos que te permitan hackear el algoritmo de búsqueda de Amazon y aumentar tus ventas",
      "Encuentra rápidamente proveedores para cualquier nuevo producto utilizando las sugerencias de Alibaba dentro de la herramienta",
    ],
  },
  {
    screen: {
      PNG: PNG_Six,
      PNG_1200: PNG_Six_1200,
      PNG_992: PNG_Six_992,
      PNG_768: PNG_Six_768,
      PNG_mob: PNG_Six_mob,
      WEBP: WEBP_Six,
      WEBP_1200: WEBP_Six_1200,
      WEBP_992: WEBP_Six_992,
      WEBP_768: WEBP_Six_768,
      WEBP_mob: WEBP_Six_mob,
    },
    buttons: [BUTTONS.INSTALL_PRO_AI_EXTENSION_FOR_CHROME_AND_EDGE],
    title: "Analiza los datos de un competidor",
    text: [
      "Monitorea sus ventas, precios, palabras clave y niveles de inventario para obtener una ventaja.",
    ],
  },
];

export const COUNTRIES = [
  { name: "EE. UU.", flag: { JPG: JPG_US, JPG_mob: JPG_US_mob } },
  { name: "Reino Unido", flag: { JPG: JPG_UK, JPG_mob: JPG_UK_mob } },
  { name: "Alemania", flag: { JPG: JPG_DE, JPG_mob: JPG_DE_mob } },
  { name: "Francia", flag: { JPG: JPG_FR, JPG_mob: JPG_FR_mob } },
  { name: "Italia", flag: { JPG: JPG_IT, JPG_mob: JPG_IT_mob } },
  { name: "España", flag: { JPG: JPG_ES, JPG_mob: JPG_ES_mob } },
  { name: "Canadá", flag: { JPG: JPG_CA, JPG_mob: JPG_CA_mob } },
  { name: "México", flag: { JPG: JPG_MX, JPG_mob: JPG_MX_mob } },
  { name: "India", flag: { JPG: JPG_IN, JPG_mob: JPG_IN_mob } },
  { name: "Japón", flag: { JPG: JPG_JP, JPG_mob: JPG_JP_mob } },
  { name: "EAU", flag: { JPG: JPG_AE, JPG_mob: JPG_AE_mob } },
  { name: "Arabia Saudita", flag: { JPG: JPG_SA, JPG_mob: JPG_SA_mob } },
  { name: "Australia", flag: { JPG: JPG_AU, JPG_mob: JPG_AU_mob } },
  { name: "Brasil", flag: { JPG: JPG_BR, JPG_mob: JPG_BR_mob } },
];
